document.addEventListener("DOMContentLoaded", () => {
  const container = document.querySelector(".scrollable-tbody");
  const rows = container.querySelectorAll("tr");
  const viewAllButton = document.getElementById("view-all-button");
  const hideButton = document.querySelector(".view-all-btn");
  const tbody = document.getElementById("variant-table-body");
  let lastVisibleRow = null;
  rows.forEach((row) => {
    const rowRect = row.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
    if (
      rowRect.top >= containerRect.top &&
      rowRect.bottom <= containerRect.bottom
    ) {
      lastVisibleRow = row;
    } else {
      row.style.opacity = "0.6";
    }
  });
  if (lastVisibleRow) lastVisibleRow.style.opacity = "0.6";
  viewAllButton.addEventListener("click", () => {
    rows.forEach((row) => {
      row.style.opacity = "1";
    });
    hideButton.style.display = "none";
    tbody.classList.toggle("overflow-y-auto");
    viewAllButton.textContent = tbody.classList.contains("overflow-y-auto")
      ? "View All"
      : "View All";
  });
});

function updateQuantity(variantId, increment) {
  const input = document.getElementById(`Quantity-${variantId}`);
  const hiddenInput = document.getElementById(`Hidden-Quantity-${variantId}`);
  const currentQty = parseInt(input.value, 10) || 0;
  const min = parseInt(input.getAttribute("min"), 10) || 1;
  const max = parseInt(input.getAttribute("max"), 10) || Infinity;
  const newQty = Math.min(max, Math.max(min, currentQty + increment));

  if (newQty !== currentQty) {
    input.value = newQty;
    hiddenInput.value = newQty;

    const price = parseFloat(input.dataset.price);
    const totalPriceElement = document.getElementById(
      `Total-Price-${variantId}`
    );
    totalPriceElement.textContent = (newQty * price).toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
  }
}

/* variant slider*/

let currentIndex = {};

function handlePreviousVariant(variantId) {
  const slider = document.getElementById(`imageSlider-${variantId}`);
  const images = slider.querySelectorAll(".variant-image");
  const prevButton = slider.querySelector(".previous-btn");
  const nextButton = slider.querySelector(".next-btn");

  if (!prevButton || !nextButton) {
    console.error("Previous or Next button not found.");
    return;
  }

  if (!currentIndex[variantId]) currentIndex[variantId] = 0;

  currentIndex[variantId] =
    (currentIndex[variantId] - 1 + images.length) % images.length;
  updateSlider(slider, images, currentIndex[variantId]);

  // Disable/enable buttons based on the current index
  prevButton.disabled = currentIndex[variantId] === 0;
  nextButton.disabled = currentIndex[variantId] === images.length - 1;
}

function handleNextVariant(variantId) {
  const slider = document.getElementById(`imageSlider-${variantId}`);
  const images = slider.querySelectorAll(".variant-image");
  const prevButton = slider.querySelector(".previous-btn");
  const nextButton = slider.querySelector(".next-btn");

  if (!prevButton || !nextButton) {
    console.error("Previous or Next button not found.");
    return;
  }

  if (!currentIndex[variantId]) currentIndex[variantId] = 0;

  currentIndex[variantId] = (currentIndex[variantId] + 1) % images.length;
  updateSlider(slider, images, currentIndex[variantId]);

  // Disable/enable buttons based on the current index
  prevButton.disabled = currentIndex[variantId] === 0;
  nextButton.disabled = currentIndex[variantId] === images.length - 1;
}

function updateSlider(slider, images, index) {
  images.forEach((image, i) => {
    image.style.display = i === index ? "block" : "none";
  });
}

document.querySelectorAll(".slider").forEach((slider) => {
  const images = slider.querySelectorAll(".variant-image");
  const prevButton = slider.querySelector(".previous-btn");
  const nextButton = slider.querySelector(".next-btn");

  if (images.length) {
    // Initially show the first image
    images.forEach(
      (image, i) => (image.style.display = i === 0 ? "block" : "none")
    );

    // Disable previous button if there is only one image
    if (prevButton && nextButton) {
      prevButton.disabled = true;
      nextButton.disabled = images.length <= 1;
    }

    // Set the currentIndex for the first image
    currentIndex[slider.id] = 0;
  }
});

/* product variant size update js */

function updateVariantId(option1, option2, form_id) {
  const productUrl = `${window.location.origin}${window.location.pathname}.json`;
  fetch(productUrl)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then((productData) => {
      const allVariants = productData.product.variants;
      const variantId = allVariants.find((variant) => {
        return variant.option1 === option1 && variant.option2 === option2;
      });

      const mainForm = document.getElementById(`drawer-${form_id}`);
      if (mainForm) {
        mainForm.querySelector(".variant_quantity").value = 1;
        mainForm.querySelector(".product-variant-id").value = variantId.id;
      }
    })
    .catch((error) => {
      console.error("Error fetching product JSON:", error);
    });
}

document.addEventListener("DOMContentLoaded", function () {
  const variantElements = document.querySelectorAll(".swatch-input__label");
  const variantDescription = document.querySelector(".variant-description");

  variantElements.forEach((variant) => {
    variant.addEventListener("click", function () {
      const descriptionHeight = variantDescription.scrollHeight;
      if (descriptionHeight > 365) {
        variantDescription.style.height = `365px`;
      }
    });
  });
});


document.querySelectorAll('[id^="Products-"] summary').forEach((summary) => {
  const details = summary.parentNode;
  const content = summary.nextElementSibling;

  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', details.hasAttribute('open'));

  if (content.getAttribute('id')) {
    summary.setAttribute('aria-controls', content.id);
  }
  if (!details.hasAttribute('open')) {
    content.style.height = '0px';
    content.style.overflow = 'hidden';
    content.style.transition = 'height 0.3s ease-out';
  }

  summary.addEventListener('click', (event) => {
    event.preventDefault();

    const details = event.currentTarget.closest('details');
    const content = summary.nextElementSibling;

    if (details.hasAttribute('open')) {
      content.style.height = content.scrollHeight + 'px';
      requestAnimationFrame(() => {
        content.style.height = '0px';
      });
      setTimeout(() => details.removeAttribute('open'), 300);
    } else {
      details.setAttribute('open', '');
      content.style.height = '0px';
      requestAnimationFrame(() => {
        content.style.height = content.scrollHeight + 'px';
      });
    }

    summary.setAttribute('aria-expanded', !details.hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});



class ScrollToSection extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', () => { this.handleClick(); });
  }
  handleClick() {
    const targetId = this.getAttribute('data-id');
    if (!targetId) return;
    const target = document.getElementById(targetId);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}
customElements.define('scroll-to-element', ScrollToSection);